module.exports = __webpack_public_path__ + "img/logo4.f3fb5977.png";